"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configure = require("../configure");
var format_number_with_string_1 = require("./format-number-with-string");
var deconstruct_number_format_1 = require("./deconstruct-number-format");
var defaults = {
    decimal: '.',
    grouping: ','
};
function default_1(options) {
    var localizer = simpleNumberLocalizer(options);
    configure.setNumberLocalizer(localizer);
    return localizer;
}
exports.default = default_1;
function simpleNumberLocalizer(options) {
    var _a = Object.assign({}, defaults, options), decimal = _a.decimal, grouping = _a.grouping;
    var localizer = {
        formats: {
            default: "-#" + grouping + "##0" + decimal
        },
        // TODO major bump consistent ordering
        parse: function (num, culture, format) {
            var value;
            if (format) {
                // TODO: handle undefined
                var data = deconstruct_number_format_1.deconstructNumberFormat(format);
                var negative = (data.negativeLeftSymbol && num.indexOf(data.negativeLeftSymbol) !== -1)
                    || (data.negativeRightSymbol && num.indexOf(data.negativeRightSymbol) !== -1);
                num = num
                    .replace(data.negativeLeftSymbol, '')
                    .replace(data.negativeRightSymbol, '')
                    .replace(data.prefix, '')
                    .replace(data.suffix, '');
                var halves = num.split(data.decimalChar);
                if (data.integerSeparator)
                    halves[0] = halves[0].replace(new RegExp('\\' + data.integerSeparator, 'g'), '');
                if (data.decimalsSeparator)
                    halves[1] = halves[1].replace(new RegExp('\\' + data.decimalsSeparator, 'g'), '');
                if (halves[1] === '')
                    halves.pop();
                num = halves.join('.');
                value = +num;
                if (negative)
                    value = -1 * value;
            }
            else
                value = parseFloat(num);
            return isNaN(value) ? null : value;
        },
        format: function (value, format) {
            return format_number_with_string_1.default(value, format);
        },
        // TODO handle undefined
        decimalChar: function (format) {
            return format && deconstruct_number_format_1.deconstructNumberFormat(format).decimalsSeparator || '.';
        },
        precision: function (format, culture) {
            // TODO handle undefined
            var data = deconstruct_number_format_1.deconstructNumberFormat(format);
            return data.maxRight !== -1 ? data.maxRight : null;
        }
    };
    return localizer;
}
exports.simpleNumberLocalizer = simpleNumberLocalizer;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/localizers/simple-number-localizer.js
// module id = 454
// module chunks = 0 1 2 3 4 5 6